import urlParser from 'bloko/common/urlParser';

import Components from 'HHC/Components';

// В момент модификации ссылка может изменить вид
// на :visited, если это состояние описано в CSS.
const addHhtmToLinkHref = (link: HTMLAnchorElement) => {
    const parsedUrl = urlParser(link.href);
    if (parsedUrl.host === window.location.host) {
        parsedUrl.params.hhtmFrom = window.globalVars.analyticsParams.hhtmSource;

        if (window.globalVars.analyticsParams.hhtmSourceLabel && !parsedUrl.params?.hhtmFromLabel) {
            parsedUrl.params.hhtmFromLabel = window.globalVars.analyticsParams.hhtmSourceLabel as string;
        }

        link.href = parsedUrl.href;
    }
};

const LINK_SELECTOR = 'a[href]:not([href*="hhtmFrom="]):not([href^="#"])';
const AddHhtmToLinks = (element: HTMLElement) => {
    if (!window.globalVars.analyticsParams.hhtmSource || !window.globalVars.features.add_hhtm_to_link_href) {
        return;
    }

    const handler = ({ target }: MouseEvent) => {
        const link = (target as HTMLElement).closest<HTMLAnchorElement>(LINK_SELECTOR);
        link && addHhtmToLinkHref(link);
    };

    element.addEventListener('click', handler);
    element.addEventListener('contextmenu', handler);
    element.addEventListener('mousedown', handler);
};

export default Components.build({ create: AddHhtmToLinks });
